import { useTranslation } from 'react-i18next';
import { Label } from '../ui/label';
import { Slider } from '../ui/slider';
import { formatGradeOpinion } from './gradeUtils';

interface GradeOpinionSliderProps {
  difficulty: string | null | undefined;
  value: number | null;
  onChange: (value: number | null) => void;
}

export function GradeOpinionSlider({ difficulty, value, onChange }: GradeOpinionSliderProps) {
  const { t } = useTranslation();
  const displayValue = value !== null ? formatGradeOpinion(difficulty, value) : null;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>{t('climbLog.gradeOpinion')}</Label>
        {displayValue !== null && (
          <span className="font-mono font-bold text-sm" data-testid="grade-opinion-value">
            {displayValue}
          </span>
        )}
      </div>
      <p className="text-xs text-muted-foreground">{t('climbLog.gradeOpinionDescription')}</p>
      <Slider
        min={0.1}
        max={0.9}
        step={0.1}
        value={[value ?? 0.5]}
        onValueChange={(v) => onChange(v[0])}
      />
      <div className="flex justify-between text-xs text-muted-foreground">
        <span>{t('climbLog.easier')}</span>
        <span>{t('climbLog.harder')}</span>
      </div>
    </div>
  );
}
